<div class="modal fade">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <ng-template [ngIf]="!editMode">
                    <h4 class="modal-title">
                        {{titleInsert}}
                    </h4>     
                    <h6 class="modal-subtitle">
                        {{subTitleInsert}}
                    </h6>                    
                </ng-template>

                <ng-template [ngIf]="editMode">
                    <h4 class="modal-title">
                        {{titleEdit}}
                    </h4>
                    <h6 class="modal-subtitle">
                        {{subTitleEdit}}
                    </h6>                    
                </ng-template>  
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entityPreBaixa"> 
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label" for="clientePreBaixa">{{clienteInputLabel}}</label>
                                <ng-template [ngIf]="canEditCliente">
                                    <sgt-typeahead-cliente [(ngModel)]="entityPreBaixa.cliente" name="clientePreBaixa" id="clientePreBaixa"
                                        #typeaeadCliente #clientePreBaixa="ngModel" [ngControl]="clientePreBaixa" required="required"
                                        (entitySelected)="onSelectCliente($event)" (clearEntity)="onClearCliente()">
                                    </sgt-typeahead-cliente>
                                    <sgt-form-control-error
                                        *ngIf="clientePreBaixa.errors && clientePreBaixa.errors.required && clientePreBaixa.dirty"
                                        msgError="O cliente é obrigatório">
                                    </sgt-form-control-error>                                                                   
                                </ng-template>

                                <ng-template [ngIf]="!canEditCliente">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                          <span class="input-group-text">{{entityPreBaixa?.cliente?.pessoa?.codigoIntegracaoErp}}</span>
                                        </div>
                                        <input type="text" class="form-control" [value]="entityPreBaixa?.cliente?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                    </div>
                                    <p class="form-text text-muted" *ngIf="entityPreBaixa?.cliente">
                                        {{entityPreBaixa?.cliente?.pessoa?.nomeFantasia}} - {{entityPreBaixa?.cliente?.pessoa?.cnpjCpf}} - {{entityPreBaixa?.cliente?.pessoa?.enderecoPrincipal?.cidade?.nome}} - {{entityPreBaixa?.cliente?.pessoa?.enderecoPrincipal?.cidade?.estado?.uf}}
                                    </p>
                                </ng-template>                                
                            </div>
                        </div>
                        <div class="row" *ngIf="!isRepresentante">
                            <div class="form-group form-group-representante col-12">
                                <label class="col-form-label">Representante</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">{{entityPreBaixa?.representante?.pessoa?.codigoIntegracaoErp}}</span>
                                    </div>
                                    <input type="text" class="form-control" [value]="entityPreBaixa?.representante?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                </div>
                                <p class="form-text text-muted" *ngIf="entityPreBaixa?.representante">
                                    {{entityPreBaixa?.representante?.pessoa?.nomeFantasia}} - {{entityPreBaixa?.representante?.pessoa?.cnpjCpf}}
                                </p>                                                                
                            </div>
                        </div>   
                        
                        <ng-template [ngIf]="editMode">
                            <div class="row">
                                <div class="form-group col-12 col-md-5 col-lg-3">
                                    <label class="col-form-label">Data</label>
                                    <input type="text" class="form-control" value="{{entityPreBaixa.dataPreBaixa | date: 'dd/MM/yyyy'}} às {{entityPreBaixa.dataPreBaixa | date: 'HH:mm'}}" disabled="disabled" readonly="readonly">
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="col-form-label">Usuário</label>
                                    <input type="text" class="form-control" [value]="entityPreBaixa.preBaixaManual ? entityPreBaixa.nomeUsuarioPreBaixa : 'Automática'" disabled="disabled" readonly="readonly">
                                </div>
                            </div>
                        </ng-template>

                        <div class="row">
                            <div class="form-group col-12">
                                <label for="motivoPreBaixaCliente" class="col-form-label">Motivo</label>
                                <textarea class="form-control" [(ngModel)]="entityPreBaixa.motivoPreBaixa" name="motivoPreBaixaCliente" id="motivoPreBaixaCliente" 
                                    #motivoPreBaixaCliente="ngModel" rows="10" required="required" minlength="15">
                                </textarea>
                                <sgt-form-control-error
                                    *ngIf="motivoPreBaixaCliente.errors && motivoPreBaixaCliente.errors.required && motivoPreBaixaCliente.dirty"
                                    msgError="O motivo é obrigatório">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="motivoPreBaixaCliente.errors && motivoPreBaixaCliente.errors.minlength"
                                    msgError="O motivo deve ter no mínimo 15 caracteres">
                                </sgt-form-control-error>                                                                                               
                            </div>
                        </div>
                    </div>
                </form>                
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="cancel()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
                <button type="button" class="btn btn-prebaixar" id="btnClientePreBaixarModal" [disabled]="!form.valid" (click)="preBaixar()">
                    <i class="far fa-window-close"></i> {{btnBaixarText}}
                </button>                
            </div>            
        </div>
    </div>
</div>